import { useTranslation } from 'next-i18next'

import SVGImage from '~/components/Image/SVGImage'

export default function Helpbox(): React.ReactElement {
  const { t } = useTranslation('booking')
  const contactClasses = 'ml-1 text-purple underline'
  return (
    <div className="bg-white border-2 p-4 border-purple rounded text-center space-y-2 w-full xl:max-w-[295px]">
      <h3 className="font-semibold">{t('helpBoxTitle')}</h3>
      <p className="">{t('helpBoxText')}</p>

      <section>
        <p className="flex items-center justify-center font-semibold text-purple">
          <SVGImage alt={t('dialerIcon')} srcKey="icons/blue-gradient-dialer.svg" />
          <span className={contactClasses}>+ 47 22 150 300</span>
        </p>
        <p className="flex items-center justify-center font-semibold text-purple">
          <SVGImage alt={t('envelopIcon')} srcKey="icons/blue-gradient-envelope.svg" />
          <a className={contactClasses} href="mailto:learn@houseofmath.com">
            learn@houseofmath.com
          </a>
        </p>
      </section>

      <p className="text-center">
        <span>{t('openingHours')}</span> <br />
        <span>08:30 - 16:30 CET</span>
      </p>
      <p className="pt-3 border-t border-0 border-gray-light">Bygdøy allé 23, 0262 Oslo</p>
    </div>
  )
}
